import { jsxs as m, jsx as r } from "react/jsx-runtime";
import y from "../container/Container.js";
import z from "../../components/heading/Heading.js";
import N from "../section-shape/SectionShape.js";
import i from "classnames";
import '../../assets/Header.css';const l = "_container_y8uzg_9", x = "_content_y8uzg_21", j = "_heading_y8uzg_30", k = "_children_y8uzg_35", n = {
  container: l,
  content: x,
  heading: j,
  children: k
}, q = ({
  as: c = "section",
  children: d,
  color: e = "dark",
  docked: a = !0,
  serifTitle: _,
  shape: o,
  shapeClassName: h,
  shapeTheme: g,
  title: u,
  titleVariant: f = "d2",
  classnames: t,
  ...p
}) => /* @__PURE__ */ m(
  y,
  {
    as: c,
    color: e,
    ...p,
    classnames: {
      content: i(n.content, t == null ? void 0 : t.content),
      container: i(n.container, t == null ? void 0 : t.container)
    },
    "data-docked": a,
    children: [
      /* @__PURE__ */ r(z, { as: "h1", variant: f, serif: _, className: n.heading, children: u }),
      /* @__PURE__ */ r("div", { className: n.children, children: d }),
      !!o && /* @__PURE__ */ r(N, { priority: !0, color: e, shape: o, shapeTheme: g, className: h })
    ]
  }
);
export {
  q as default
};
